import Link from 'next/link'
import { useRouter } from 'next/router'
import styles from './integrations.module.css'

export interface CategoryProps {
  categories: string[]
  selectedCategory?: string
}
export function Category({
  categories,
  selectedCategory
}: CategoryProps): JSX.Element {
  const router = useRouter()
  const categoryPath = (category: string) =>
    `/integrations/category/${encodeURIComponent(category.toLowerCase())}`
  return (
    <aside className={styles.categories}>
      <nav className={styles.categoryNav} aria-label="Integration categories">
        <p>Browse by category</p>
        <Link
          href="/integrations#integration-list"
          aria-current={!selectedCategory ? 'page' : undefined}
        >
          All integrations
        </Link>
        {categories.map(category => (
          <Link
            key={category}
            href={`${categoryPath(category)}#integration-list`}
            aria-current={category === selectedCategory ? 'page' : undefined}
          >
            {category}
          </Link>
        ))}
      </nav>
      <div className={styles.categorySelect}>
        <label htmlFor="integration-category">Browse by category</label>
        <select
          id="integration-category"
          value={
            selectedCategory ? categoryPath(selectedCategory) : '/integrations'
          }
          onChange={event =>
            router.push(`${event.target.value}#integration-list`)
          }
        >
          <option value="/integrations">All integrations</option>
          {categories.map(category => (
            <option key={category} value={categoryPath(category)}>
              {category}
            </option>
          ))}
        </select>
      </div>
    </aside>
  )
}
